import OrderCreate from "@/components/order/create.vue"
export default {
    components : {
        OrderCreate
    }
}
